import type { LucideIcon } from "lucide-react";

export interface InfoStripItem {
  icon: LucideIcon;
  label: string;
  value: string;
  href?: string;
}

interface RegionalInfoStripProps {
  items: InfoStripItem[];
}

// Franja de datos generales del aeropuerto en grid edge-to-edge
export default function RegionalInfoStrip({ items }: RegionalInfoStripProps) {
  return (
    <section className="py-16">
      <div className="max-w-[80%] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-gray-200 rounded-2xl overflow-hidden border border-gray-200">
          {items.map((item) => (
            <div
              key={item.label}
              className="bg-white p-8 transition-colors hover:bg-gray-50"
            >
              <item.icon className="w-6 h-6 text-[#102542] mb-4" />
              <p className="text-xs font-mono uppercase tracking-wider text-gray-400 mb-1">
                {item.label}
              </p>
              {item.href ? (
                <a
                  href={item.href}
                  className="font-semibold text-gray-900 hover:text-[#102542] transition-colors"
                >
                  {item.value}
                </a>
              ) : (
                <p className="font-semibold text-gray-900">{item.value}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
